import { reviews, reviewStats } from '@/mocks/reviews';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <div key={star} className="w-4 h-4 flex items-center justify-center">
          <i
            className={`text-sm ${star <= rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
            style={star <= rating ? { color: '#F59E0B' } : {}}
          ></i>
        </div>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            用户真实评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            来自千万用户的真实反馈，您的满意是我们最大的动力
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-72 flex-shrink-0">
            <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 text-center">
              <p className="text-5xl font-heading font-bold text-foreground-900 mb-1">{reviewStats.averageRating}</p>
              <StarRating rating={5} />
              <p className="text-sm text-foreground-500 mt-2">{reviewStats.totalReviews.toLocaleString()} 条评价</p>
              <div className="mt-5 space-y-2">
                {reviewStats.ratingDistribution.map((item) => (
                  <div key={item.stars} className="flex items-center gap-2">
                    <span className="text-xs text-foreground-500 w-6">{item.stars}星</span>
                    <div className="flex-1 h-2 bg-background-200 rounded-full overflow-hidden">
                      <div
                        className="h-full rounded-full"
                        style={{
                          width: `${item.percentage}%`,
                          backgroundColor: item.stars >= 4 ? '#F59E0B' : '#D1D5DB',
                        }}
                      ></div>
                    </div>
                    <span className="text-xs text-foreground-400 w-8">{item.percentage}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-5">
            {reviews.slice(0, 6).map((review) => (
              <div
                key={review.id}
                className="bg-background-100 border border-background-200/70 rounded-lg p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-400">{review.location} · {review.date}</p>
                  </div>
                  <StarRating rating={review.rating} />
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {review.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}